export default __webpack_public_path__ + "static/media/exit.e8eaca4e.svg";